import React, { useState } from "react";
import "./BlogList.css";
import { motion } from "framer-motion";

const BlogList = ({ posts = [] }) => {
  const [activeTab, setActiveTab] = useState("All");

  // Extract categories from posts + add All
const categories = [
  "All",
  ...new Set(posts.map((p) => p.category).filter(Boolean))
];

  // Filter posts based on selected tab
  const filteredPosts =
    activeTab === "All"
      ? posts
      : posts.filter((p) => p.category === activeTab);

  return (
    <div className="blog-list-section">
      <h2 className="blog-list-title">Our Blogs</h2>

      {/* TABS */}
      <div className="blog-tabs">
        {categories.map((cat, i) => (
          <button
            key={i}
            className={`blog-tab ${activeTab === cat ? "active" : ""}`}
            onClick={() => setActiveTab(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* BLOG LIST */}
      <div className="blog-list">
        {filteredPosts.map((post, index) => (
          <motion.div
            className="blog-card"
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            <div className="blog-img">
              <img src={post.image} alt={post.title} title={post.title} />
            </div>

            <div className="blog-content">
              <a href={post.link} className="blog-title">
                {post.title}
              </a>

              <p className="blog-desc">{post.description}</p>

              <div className="blog-meta">
                <span>{post.readTime} min read</span>
                <span>•</span>
                <span>{post.views} views</span>
              </div>

              <div className="blog-footer">
                <span className="likes">❤️ {post.likes}</span>
                <a href={post.link} className="read-more">
                  Read More →
                </a>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
